import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { fonts, oldFontSizes } from '../../style/theme';

const errorStyle = (error, errorWidth) => css`
  border: 1px solid var(--error-red);
  color: var(--error-red);
  font-family: ${fonts.Sans};
  font-size: ${oldFontSizes.caption};
  padding: 3px 5px;
  border-radius: 4px;
  text-align: center;
  width: ${errorWidth || 'fit-content'};
  height: fit-content;
  display: ${error ? 'inline' : 'none'};
`;

function InputError(props) {
  const { error, errorWidth, injectCss, className, id, inputId } = props;
  return (
    <div
      css={[errorStyle(error, errorWidth), injectCss]}
      className={className}
      id={id}
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      {...(inputId && { 'aria-describedby': id })}
    >
      {error}
    </div>
  );
}

InputError.defaultProps = {
  error: '',
  errorWidth: '',
  injectCss: {},
  id: undefined,
  inputId: undefined,
};

InputError.propTypes = {
  error: PropTypes.string,
  errorWidth: PropTypes.string,
  injectCss: PropTypes.objectOf(PropTypes.string),
  id: PropTypes.string,
  inputId: PropTypes.string,
};

export default InputError;
